import PropTypes from 'prop-types';
import IconedLink from '@/components/common/iconedLinks/IconedLink';
import { URLS } from '@/constants/urls';

const DeleteIconedLink = ({ id, onDelete, rbf }) => (
  <IconedLink
    id={id}
    text={'btn.delete'}
    icon={URLS.ORION_CLOSE_BLACK}
    width={10}
    height={10}
    onClicked={onDelete}
    rbf={rbf}
  />
);

DeleteIconedLink.propTypes = {
  id: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  rbf: PropTypes.string
};

export default DeleteIconedLink;
